import React from "react";
import { Link } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

function RegisterProfesseurSuccess() {
  return (
    <section className="signup-area">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            <div
              className="signup-form"
              style={{
                textAlign: "center",
                padding: "3rem 2rem",
                marginTop: "2rem",
              }}
            >
              <CheckCircleOutlineIcon
                sx={{ fontSize: 80, color: "#2e7d32", mb: 2 }}
              />
              <h2 style={{ marginBottom: "1rem", fontFamily: "arial" }}>
                Préinscription réussie
              </h2>
              <p style={{ fontSize: "1.1rem", marginBottom: "1.5rem", lineHeight: 1.6 }}>
                Votre demande de préinscription en tant que professeur a bien été
                enregistrée. Nous vous contacterons pour fixer le jour de
                l'entretien.
              </p>
              <Link to="/" className="box-btn" style={{ textDecoration: "none" }}>
                Retour à l'accueil
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default RegisterProfesseurSuccess;
